(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igear-cod-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-igear-root]');
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const storageKey = 'igear_attribution_v1';

    const readAttribution = () => {
      const params = new URLSearchParams(window.location.search);
      let saved = {};
      try {
        saved = JSON.parse(localStorage.getItem(storageKey) || '{}');
      } catch (error) {
        saved = {};
      }
      const fresh = {};
      utmKeys.forEach((key) => {
        const value = params.get(key);
        if (value) fresh[key] = value.slice(0, 180);
      });
      if (Object.keys(fresh).length) {
        saved = { ...saved, ...fresh, saved_at: Date.now() };
        try {
          localStorage.setItem(storageKey, JSON.stringify(saved));
        } catch (error) {
          saved = { ...saved };
        }
      }
      if (saved.saved_at && Date.now() - Number(saved.saved_at) > 30 * 24 * 60 * 60 * 1000) return {};
      return saved;
    };

    const formatMad = (amount) => {
      if (!Number.isFinite(amount)) return '';
      return new Intl.NumberFormat('fr-MA', { style: 'currency', currency: 'MAD', maximumFractionDigits: amount % 1 ? 2 : 0 }).format(amount);
    };

    roots.forEach((root) => {
      if (root.dataset.igearReady === 'true') return;
      root.dataset.igearReady = 'true';
      const form = root.querySelector('[data-order-form]');
      if (!form) return;

      const endpoint = root.dataset.endpoint.trim();
      const frame = root.querySelector('[data-response-frame]');
      const status = root.querySelector('[data-form-status]');
      const submitButton = root.querySelector('[data-submit-button]');
      const submitLabel = root.querySelector('[data-submit-label]');
      const successPanel = root.querySelector('[data-success-panel]');
      const quantity = form.querySelector('[data-quantity]');
      const variant = form.querySelector('[data-variant-select]');
      const attribution = readAttribution();
      let unitPrice = Number(root.dataset.priceValue || 0);
      const shippingValue = Number(root.dataset.shippingValue || 0);
      const shippingConfigured = !root.dataset.shippingLabel.includes('[');
      let priceLabel = root.dataset.priceLabel;
      let activeNonce = '';
      let responseTimer;

      utmKeys.forEach((key) => {
        const input = form.elements.namedItem(key);
        if (input) input.value = attribution[key] || '';
      });
      form.elements.namedItem('page_url').value = window.location.href.slice(0, 500);
      form.elements.namedItem('referrer').value = document.referrer.slice(0, 500);
      form.elements.namedItem('submitted_at').value = String(Date.now());

      const updateSummary = () => {
        const qty = Math.max(1, Number(quantity.value || 1));
        if (variant && variant.selectedOptions[0]) {
          const option = variant.selectedOptions[0];
          unitPrice = Number(option.dataset.price || unitPrice);
          priceLabel = option.dataset.priceLabel || priceLabel;
        }
        const calculable = unitPrice > 0 && shippingConfigured && shippingValue >= 0;
        const total = calculable ? unitPrice * qty + shippingValue : 0;
        root.querySelector('[data-summary-quantity]').textContent = String(qty);
        root.querySelector('[data-summary-product]').textContent = unitPrice > 0 ? formatMad(unitPrice * qty) : priceLabel;
        root.querySelector('[data-summary-total]').textContent = calculable ? formatMad(total) : '[TOTAL]';
        form.querySelector('[data-form-price]').value = unitPrice > 0 ? formatMad(unitPrice) : priceLabel;
        form.querySelector('[data-form-total]').value = calculable ? formatMad(total) : '[TOTAL]';
        root.querySelectorAll('[data-price-output], [data-order-unit-price], [data-final-price], [data-mobile-price]').forEach((node) => {
          node.textContent = unitPrice > 0 ? formatMad(unitPrice) : priceLabel;
        });
      };

      const showFieldError = (field, message) => {
        const label = field.closest('.igear-field');
        if (label) label.classList.toggle('is-invalid', Boolean(message));
        const errorNode = form.querySelector(`[data-error-for="${field.name}"]`);
        if (errorNode) errorNode.textContent = message;
      };

      const validate = () => {
        let valid = true;
        const name = form.elements.namedItem('customer_name');
        const phone = form.elements.namedItem('phone');
        const city = form.elements.namedItem('city');
        const address = form.elements.namedItem('address');
        const normalizedPhone = phone.value.replace(/[\s().-]/g, '');
        const phoneValid = /^(?:\+?212|0)?[5-7]\d{8}$/.test(normalizedPhone);

        [[name, name.value.trim().length >= 2 ? '' : 'Indiquez votre nom complet.'], [phone, phoneValid ? '' : 'Entrez un numéro marocain valide.'], [city, city.value.trim().length >= 2 ? '' : 'Indiquez votre ville.'], [address, address.value.trim().length >= 5 ? '' : 'Ajoutez une adresse suffisamment précise.']].forEach(([field, message]) => {
          showFieldError(field, message);
          if (message) valid = false;
        });
        return valid;
      };

      const setLoading = (loading) => {
        form.classList.toggle('is-loading', loading);
        submitButton.disabled = loading;
        submitLabel.textContent = loading ? 'Envoi en cours…' : 'Confirmer ma commande';
      };

      const showFailure = (message) => {
        window.clearTimeout(responseTimer);
        setLoading(false);
        status.classList.remove('is-success');
        status.textContent = message || 'Impossible d’enregistrer la commande. Vérifiez votre connexion puis réessayez.';
      };

      const showSuccess = () => {
        window.clearTimeout(responseTimer);
        setLoading(false);
        form.hidden = true;
        successPanel.hidden = false;
        successPanel.focus();
        if (window.dataLayer && Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: 'cod_order_success', product_name: root.dataset.productName });
        }
      };

      window.addEventListener('message', (event) => {
        if (event.source !== frame.contentWindow) return;
        const payload = event.data;
        if (!payload || payload.type !== 'igear-cod-response' || payload.nonce !== activeNonce) return;
        if (payload.ok) showSuccess();
        else showFailure(payload.message);
      });

      form.addEventListener('input', (event) => {
        if (event.target.name) showFieldError(event.target, '');
      });
      quantity.addEventListener('change', updateSummary);
      if (variant) variant.addEventListener('change', updateSummary);

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        status.textContent = '';
        if (!validate()) {
          const firstInvalid = form.querySelector('.is-invalid input, .is-invalid textarea, .is-invalid select');
          if (firstInvalid) firstInvalid.focus();
          return;
        }
        if (!endpoint || !/^https:\/\/script\.google\.com\//.test(endpoint)) {
          showFailure('Ajoutez d’abord l’URL Google Apps Script dans les réglages de la section.');
          return;
        }
        activeNonce = `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
        form.elements.namedItem('client_nonce').value = activeNonce;
        form.elements.namedItem('submitted_at').value = String(Date.now());
        updateSummary();
        setLoading(true);
        responseTimer = window.setTimeout(() => {
          showFailure('La confirmation prend trop de temps. Vérifiez votre connexion puis réessayez.');
        }, 25000);
        HTMLFormElement.prototype.submit.call(form);
      });

      updateSummary();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
